// External deps
import React, { useRef, useState } from "react";
import PropTypes from 'prop-types';
import { DateInput, ModalGeneric } from 'ypf-pas-general-ui-components';
import { Formik } from "formik";
import { Form, Row, Col } from "react-bootstrap";
import * as yup from 'yup';

// Intenal deps
import useLoading from "../../hooks/useLoading";
import { showSuccess, showError } from "../../utils/toastUtils";
import { postUserTrazabilityReportAdapter } from "../../adapters/userRequestsAdapter";

const VALIDATION_SCHEMA = yup.object().shape({
  dateFrom: yup
    .date()
    .max(new Date(), 'La fecha desde no puede ser mayor a la fecha actual')
    .max(yup.ref('dateTo'), 'La fecha desde no puede ser mayor a la fecha hasta ')
    .required('Debe seleccionar una fecha desde'),
  dateTo: yup
    .date()
    .max(new Date(), 'La fecha hasta no puede ser mayor a la fecha actual')
    .min(yup.ref('dateFrom'), 'La fecha hasta no puede ser menor a la fecha desde ')
    .required('Debe seleccionar una fecha hasta')
});
const ModalUserTrazability = ({ showTrazabilityModal, setShowTrazabilityModal, firstDateRequest }) => {
  const [disabledPrimaryButton, setDisabledPrimaryButton] = useState(false);
  const { setLoading } = useLoading();
  const formRef = useRef(null);
  const today = new Date().toISOString().split('T')[0];
  const firstDateRequestConvert = new Date(firstDateRequest).toISOString().split('T')[0];
  const initialValues = {
    dateFrom: firstDateRequestConvert,
    dateTo: today
  };
  const onCloseModalUserTrazability = () => {
    setShowTrazabilityModal(false);
  };

  const downloadReports = (values) => {
    setLoading(true);
    const nameFile = 'Informe de trazabilidad de usuarios';
    postUserTrazabilityReportAdapter(values, nameFile)
      .then(() => {
        showSuccess('Se ha descargado archivo correctamente');
        setLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }).catch((err) => {
        showError(err);
        setLoading(false);
      });
  };
  if (firstDateRequest === null) return null;
  return (
    <ModalGeneric
      title="Descargar informe de trazabilidad de usuarios"
      size="m"
      show={showTrazabilityModal}
      onHide={onCloseModalUserTrazability}
      infoModal
      backdrop="static"
      secondaryActionLabel="Salir"
      secondaryActionVariant="outline-primary"
      secondaryAction={() => onCloseModalUserTrazability()}
      primaryActionLabel="Aceptar"
      primaryActionDisabled={disabledPrimaryButton}
      primaryActionVariant={disabledPrimaryButton ? 'secondary' : 'primary'}
      primaryAction={() => formRef.current.handleSubmit()}
    >
      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={(values) => downloadReports(values)}
      >
        {({
          values, errors, touched, setFieldValue, setFieldTouched, isValid
        }) => (
          <Form>
            {setDisabledPrimaryButton((!isValid || (values.dateFrom === null || values.dateTo === null)))}
            <Row>
              <Col sm={12}>
                <DateInput
                  label="Fecha desde"
                  name="dateFrom"
                  className="adm-date-input-error"
                  onChange={(value) => {
                    setFieldTouched('dateFrom');
                    setFieldValue('dateFrom', value.target.value);
                  }}
                  onClear={() => setFieldValue('dateFrom', '')}
                  placeholder="Buscar por fecha desde"
                  value={values.dateFrom}
                  widthDateInput="100%"
                  isInvalid={!!errors.dateFrom && touched.dateFrom}
                  errors={errors.dateFrom}
                  min={initialValues.dateFrom}
                  max={values.dateTo}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <DateInput
                  label="Fecha hasta"
                  name="dateTo"
                  onChange={(value) => {
                    setFieldTouched('dateTo');
                    setFieldValue('dateTo', value.target.value);
                  }}
                  onClear={() => setFieldValue('dateTo', '')}
                  placeholder="Buscar por fecha hasta"
                  value={values.dateTo}
                  widthDateInput="100%"
                  isInvalid={!!errors.dateTo && touched.dateTo}
                  errors={errors.dateTo}
                  min={values.dateFrom}
                  max={today}
                />
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </ModalGeneric>
  );
};

ModalUserTrazability.propTypes = {
  showTrazabilityModal: PropTypes.bool,
  setShowTrazabilityModal: PropTypes.func,
  firstDateRequest: PropTypes.string
};
ModalUserTrazability.defaultProps = {
  showTrazabilityModal: false,
  setShowTrazabilityModal: () => {},
  firstDateRequest: ''
};
export default ModalUserTrazability;